import React, { useEffect, useRef, useState } from 'react';

import CassetteCircular from '../../../../uploads/Photos/Home-Screen/Cassette/circular.png'
import CassetteBladeless from '../../../../uploads/Photos/Home-Screen/Cassette/bladeless.png'
import CassetteCircularDesign from '../../../../uploads/Photos/Home-Screen/Cassette/circular_design.png'

import './360Cassette.css'
import { Typography } from '@material-tailwind/react';
import Card from './CassetteCards';
import { Helmet } from 'react-helmet';

const items = [
    {
      image: CassetteCircular,
      title: 'Кружен дизајн',
      description:
        'Неговиот дизајн со целосен круг овозможува да се постави убаво за да одговара на вашите естетски дизајни на ентериер.',
    },
    {
      image: CassetteBladeless,
      title: 'Без сечило',
      description: 'Дизајнот без сечила значи дека нема лопатки за решетки што го попречуваат протокот на воздух, зголемувајќи ја испораката на протокот на воздух. Дизајнот на засилувачот на вентилаторот Samsung овозможува поставки за насочен проток на воздух без потреба од лопатки за решетки.',
    },
    {
      image: CassetteCircularDesign,
      title: 'Балансирана климатизација',
      description: 'Иновативниот проток на воздух од 360 степени обезбедува оптимална климатизација, минимизирајќи ги жешките и студените точки, придонесувајќи за брза и рамномерна контрола на температурата.',
    },
  ];

export default function Cassette () {
    const [imageVisible, setImageVisible] = useState(false);
    const [isIos, setIsIos] = useState(false);
    const imageContainerRef = useRef(null)

    const detectIos = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPad|iPhone|iPod/.test(userAgent)) {
          setIsIos(true);
        }
      };

    useEffect( () => {
        detectIos();
        const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                entry.target.classList.add('blur-none');
                entry.target.classList.add('evening');
                observer.unobserve(entry.target);
            }
            });
        },
        { threshold: 0.8 }
        );

        if (imageContainerRef.current) {
        observer.observe(imageContainerRef.current);
        }

        return () => {
            if (imageContainerRef.current) {
                observer.unobserve(imageContainerRef.current);
            }
        };
    })

    return (
        <div>
            <Helmet>
                <title>EES | 360 Cassette</title>
                <meta name="title" content="360 Cassette | Елегантен и Ефикасен Климатизер" />
                <meta name="description" content="Откријте го нашиот 360 Cassette климатизер со стилски дизајн и одлични перформанси." />
                <meta name="keywords" content="360 Cassette, климатизер, дизајн, перформанси" />
            </Helmet>
            <div id='cassette' ref={imageContainerRef} className="w-full h-[90.5vh] flex items-center justify-center overflow-hidden">
            </div>
            <div
                style={{ background: '#fff' }}
                className="py-16 px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 rounded-3xl rounded-b-md"
            >
                <Typography className='font-normal' >
                    360 Cassette на Samsung нуди модерно решение што рамномерно го распоредува воздухот во секој агол на просторијата¹, одржувајќи пријатна температура во просторот без создавање провев.
                    Со својот иновативен тркалезен дизајн, дава доза на софистицираност и впечатлив изглед во секој простор. 360 Cassette е достапна во црна и во бела боја, во квадратен или во тркалезен дизајн, и може да се монтира на повеќе локации.
                </Typography>
                <div className="mt-10">
                    <Card items={items} />
                </div>
            </div>

        </div>
    )
}